import { render, staticRenderFns } from "./TransferRights.vue?vue&type=template&id=02202c7e"
import script from "./TransferRights.vue?vue&type=script&lang=js"
export * from "./TransferRights.vue?vue&type=script&lang=js"
import style0 from "./TransferRights.vue?vue&type=style&index=0&id=02202c7e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports